<template>
  <span
    class="ex-badge-container"
    :class="[rounded && 'rounded-full', bgClass, textClass]"
  >{{ label }}</span>
</template>

<script setup lang="ts">
interface IProps {
  label: string
  paddingX: string | number
  paddingY: string | number
  bgColor?: string
  bgOpacity?: string | number | undefined
  rounded?: boolean
  textColor?: string
  textSize?: string
}

const props = withDefaults(defineProps<IProps>(), {
  bgColor: 'point-color',
  bgOpacity: undefined,
  rounded: true,
  textColor: 'primary',
  textSize: 'base',
})

const paddingSize = computed(() => {
  return `${props.paddingY}px ${props.paddingX}px`
})

const bgClass = computed(() => {
  if (props.bgOpacity) {
    return `bg-${props.bgColor}/${props.bgOpacity}`
  }
  return `bg-${props.bgColor}`
})

const textClass = computed(() => {
  return `text-${props.textColor} font-bold text-${props.textSize}`
})
</script>

<style scoped lang="scss">
.ex-badge-container {
  padding: v-bind(paddingSize);
}
</style>